import { getApp2AppLocalBaseURL } from './companion-screen';

const PAIRING_MESSAGE = 'KINETON_PAIRING_MESSAGE';

export default class WSServer {

    start = (params) => {
        const _appEndpoint = params && params.appEndpoint !== undefined ? params.appEndpoint : `com.kineton.cs.${new Date().getTime()}`;
        const _onServerStarted = params && params.onServerStarted !== undefined ? params.onServerStarted : () => console.log('WSServer started!');
        const _onServerFailed = params && params.onServerFailed !== undefined ? params.onServerFailed : (e) => console.log('WSServer is not initialized.', e);
        try {
            this.localBaseURL = getApp2AppLocalBaseURL();
            this.ws = new WebSocket(this.localBaseURL + _appEndpoint);
            _onServerStarted();
        } catch (e) {
            _onServerFailed(e);
        }
    }

    addCommunicationListener = (events = []) => {
        if (!Array.isArray(events))
            return;
        this.ws.onmessage = (evt) => {
            if (evt.data === 'pairingcompleted') return;
            console.log('lib received command', evt);
            console.log('lib events', events);
            const eventAsJSON = JSON.parse(evt.data);
            console.log('lib', eventAsJSON);
            const eventToLaunch = events.filter(event => event.command === eventAsJSON.command);
            console.log('lib eventToLaunch', eventToLaunch, eventToLaunch.length, eventToLaunch.callback);
            if (eventToLaunch.length > 0)
                for (let i of eventToLaunch) {
                    if (i.callback) {
                        try {
                            const parsed = JSON.parse(evt.data);
                            delete parsed.command;
                            console.log('qui', parsed)
                            i.callback(parsed);
                        } catch (e) {
                            console.log('addCommunicationListener error', e);
                        }
                    }
                }

        }
    }

    sendMessage = (message) => {
        const _message = message ? message : 'DEFAULT_MESSAGE';
        this.ws.send(_message);
    }
}